// extracted by mini-css-extract-plugin
module.exports = {"language":"Language-module--language--3sdPC","name":"Language-module--name--qzdoy","level":"Language-module--level--305PX"};